import { SupportedLanguageCode } from '@spotify-internal/pillow-talk-too';

import { Vertical } from 'utils/vertical';

const toLowerCase = (locales: string[]) => locales.map(l => l.toLowerCase());

export const SUPPORTED_MESSAGING_LOCALES = {
  [Vertical.ARTISTS]: toLowerCase(['en-US', 'es-LA', 'es-ES', 'fr-CA', 'fr-FR', 'pt-BR'] as SupportedLanguageCode[]),
  [Vertical.CONSUMER]: toLowerCase([
    'ar',
    'de-DE',
    'en-US',
    'es-ES',
    'es-LA',
    'fr-CA',
    'fr-FR',
    'hi-IN',
    'id-ID',
    'it-IT',
    'ja-JP',
    'ko-KR',
    'nl-NL',
    'pl-PL',
    'pt-BR',
    'ru-RU',
    'sv-SE',
    'th-TH',
    'tr-TR',
    'vi-VN',
    'zh-TW',
  ]),
  [Vertical.PODCASTERS]: toLowerCase(['en-US'] as SupportedLanguageCode[]),
};
